import { createContext, useContext, useEffect, useState } from "react";
import { useMachine } from "@xstate/react";
import createAuthMachine from "../machines/authentication";
import { useCreateReportMachine } from "./CreateReportMachineContext";
import { useViewEditReportMachine } from "./ViewEditReportMachineContext";
import { useListReportsMachine } from "./ListReportsMachineContext";

const AuthContext = createContext({});

export const useAuth = () => {
  return useContext(AuthContext);
};

const authMachine = createAuthMachine({
  maxRefreshRetries: 3,
  refreshRetriesDelay: 5000,
  url: process.env.REACT_APP_KC_URL || "https://auth.local.orpea-belgium.com/",
  realm: process.env.REACT_APP_KC_REALM || "leadtool-v3-local",
  clientId: process.env.REACT_APP_KC_CLIENT_ID || "qmstool-v1-frontend",
});

export const AuthContextProvider = ({ children }) => {
  const [createReportMachine, sendCreate] = useCreateReportMachine();
  const [viewEditReportMachine, sendViewEdit] = useViewEditReportMachine();
  const [listReportsMachine, sendList] = useListReportsMachine();
  const refViewEdit = useViewEditReportMachine();
  const [state, send] = useMachine(authMachine);

  const value = {
    isAuthenticated: state.matches("authenticated"),
    keycloak: state.context.keycloak,
    profile: state.context.profile,
    state: state,
    send: send,
  };

  useEffect(() => {
    sendCreate("SET_EDIT_REPORT_MACHINE_REF", {
      data: refViewEdit,
    });
  }, []);

  useEffect(() => {
    console.log("AuthContext: token updated, sending to other machines");
    sendCreate("UPDATE_BEARER_TOKEN", { data: state.context.keycloak.token });
    sendViewEdit("UPDATE_BEARER_TOKEN", { data: state.context.keycloak.token });
    sendList("UPDATE_BEARER_TOKEN", { data: state.context.keycloak.token });
  }, [state.context.keycloak.token]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
